import React, {useContext} from "react";
import {getAllConfigurationProducts} from "../utils/getAllConfigurationEntities";
import ConfiguratorContext from "./ConfiguratorContext";
import {FormattedMessage} from "react-intl";
import {ArrowTopRightOnSquareIcon} from "@heroicons/react/24/solid";
import AuthenticationService from "../services/AuthenticationService";
import CountryContext from "../CountryContext";

export const linkColumns = {
  aggregated: ["link_dop", "link_cam", "link_epd", "link_sds", "link_voc"],
  single: ["link_scheda_tecnica", "link_video"],
};

const ConfiguratorSurveySummaryStepProductsLinks = ({role}) => {

  const context = useContext(ConfiguratorContext);
  const {country} = useContext(CountryContext);

  const userData = AuthenticationService.getUserData();

  const products = getAllConfigurationProducts(context, role)
    .filter((p, idx, arr) =>
      idx === arr.findIndex((t) => t.id === p.id)  // Remove duplicates
      && ([...linkColumns.aggregated, ...linkColumns.single].some((key) => !!p?.[key]))  // Keep only products with links
    )
  const isLinkValid = (link) => !!link && link.startsWith("http");
  const renderLink = (text, href, onClick=() => {}) => (
    <a className="flex flex-row gap-1 items-center" href={href} target="_blank" rel="noreferrer" onClick={onClick}>
      <ArrowTopRightOnSquareIcon className={`w-4 text-${userData.business}-400`}/>
      <p className="text-black underline capitalize">{text}</p>
    </a>
  )

  if (
    !products.length
    || products.every((p) => [...linkColumns.aggregated, ...linkColumns.single].every((key) => !p?.[key]))
  )
    // Early return if no products or no links
    return null;

  return (
    <div className="flex flex-col gap-5 mt-8 mb-4 pb-8 border-b border-black">
      <h3 className="text-2xl">
        <FormattedMessage id="products_documentation" defaultMessage="Documentazione prodotti" />
      </h3>
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 w-full gap-x-5 gap-y-3">
        {products.map((p) => {
          const type = p.is_in_pricebook === undefined ? "standard" : "kcolor";
          const name = type === "standard" ? p.art_des_it : p.des_prod_comm;
          return (
            <React.Fragment key={`${type}-${p.id}`}>
              <h4 className="text-base font-medium uppercase">
                {name}
              </h4>
              <div className="flex flex-row flex-wrap gap-x-3 lg:col-span-2">
                {linkColumns.single.filter((k) => isLinkValid(p[k])).map((k) => {
                  let text;
                  switch (k) {
                    case "link_scheda_tecnica":
                      text = <FormattedMessage id="technical_sheet"/>;
                      break;
                    case "link_video":
                      text = <FormattedMessage id="video"/>;
                      break;
                    default:
                      text = k;
                  }
                  return <React.Fragment key={k}>{renderLink(text, p[k])}</React.Fragment>
                })}
                {!!p.id && linkColumns.aggregated.some((k) => !!p[k]?.split(",").some(isLinkValid)) && renderLink(
                  <FormattedMessage id="technical_documentation" defaultMessage="Documentazione tecnica (ZIP)"/>,
                  `/${country.code}/product/${type}/${p.id}/documents?autoclose=true`,
                )}
              </div>
            </React.Fragment>
          )
        })}
      </div>
    </div>
  );
};

export default ConfiguratorSurveySummaryStepProductsLinks;
